export default __webpack_public_path__ + "static/media/PiggyBank.f1e59e23.png";